import Slider from "react-slick";
import { slickDot } from "../../utils/script";

const TestimonialData = [
    {
        form: "JAPAN",
        description: "It has been a wonderful experience working with YGS Web Solutions Pvt. Ltd. They are very efficient, effective and professional. The best part about YGS Web Solutions is their exceptional customer services. They value their customers needs and guide us kindly and thoughtfully through out the project. We would highly recommend YGS Web Solutions to everyone and we look forward to work with them as a long term customer.",
        name: "ALICE KOIZUMI",
        subtitle: "MARUHACHI RA-MEN",
        image: "testimonial-dark-01"
    },
    {
        form: "Germany",
        description: "One of the most reliable and professional companies in the industry. We have been working with YGS Web Solutions Pvt. Ltd. for over 3 years and they have been patient, knowledgeable, and professional. Thanks YGS Web Solutions Pvt. Ltd.",
        name: "Hamed Eslamie",
        subtitle: "VORTEX RESTAURANT EQUIPMENT",
        image: "testimonial-dark-02"
    },
    {
        form: "Canada",
        description: "The YGS Web Solutions Pvt. Ltd. Team is extremely flexible and accommodating. They worked closely with us throughout the process of implementation, design and revisions until we were satisfied.",
        name: "Zane Mohammed",
        subtitle: "BUY RITE BUSINESS FURNISHINGS",
        image: "testimonial-dark-03"
    },
]
const TestimonialThree = ({ teamStyle }) => {
    return (
        <div className="row">
            <div className="col-lg-12">
                <Slider className="slick-space-gutter--15 rn-slick-dot rn-slick-arrow mb--60" {...slickDot}>
                    {TestimonialData.map((data, index) => (
                        <div key={index} className={`testimonial-style-two ${teamStyle}`}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {/* <div className="order-2 order-md-1 col-lg-6 col-md-8 offset-lg-1"> */}
                                <div className="content mt_sm--40 w-75 align-items-center">
                                    <span className="form">{data.form}</span>
                                    <p className="description" style={{ fontSize: '2rem' }}>{data.description}</p>
                                    <div className="client-info">
                                        <h4 className="title">{data.name}</h4>
                                        <h6 className="subtitle">{data.subtitle}</h6>
                                    </div>
                                </div>
                                {/* </div> */}
                                {/* <div className="order-1 order-md-2 col-lg-4 col-md-4">
                                    <div className="thumbnail">
                                        <img className="w-100" src={`./images/testimonial/${data.image}.jpg`} alt="Corporate React Template" />
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    )
}
export default TestimonialThree;




















